import * as Immutable from "immutable";
import WidgetConfig from "views/logic/widgets/WidgetConfig";
import Direction from "views/logic/aggregationbuilder/Direction";
import InvestigationsWidgetSortConfig from "./InvestigationsWidgetSortConfig";
export const LIST_MODE = "List";
export const NUMBER_MODE = "Number";
const _InvestigationsWidgetConfig = class _InvestigationsWidgetConfig extends WidgetConfig {
  constructor(fields, filters, sort, mode) {
    super();
    this._value = { fields, filters, sort, mode };
  }
  get fields() {
    return this._value.fields;
  }
  get filters() {
    return this._value.filters;
  }
  get sort() {
    return this._value.sort;
  }
  get mode() {
    return this._value.mode;
  }
  toBuilder() {
    return new Builder(Immutable.Map(this._value));
  }
  toJSON() {
    const { fields = Immutable.OrderedSet(), filters = Immutable.OrderedSet(), sort, mode } = this._value;
    return {
      fields: fields.toArray(),
      filters: filters.toArray(),
      sort: sort.toJSON(),
      mode
    };
  }
  static builder() {
    return new Builder().fields(Immutable.OrderedSet()).filters(Immutable.OrderedSet());
  }
  static fromJSON(value) {
    const { fields, filters, sort, mode } = value;
    return new _InvestigationsWidgetConfig(
      Immutable.OrderedSet(fields),
      Immutable.OrderedSet(filters),
      InvestigationsWidgetSortConfig.fromJSON(sort),
      mode
    );
  }
  static createDefault() {
    return new _InvestigationsWidgetConfig(
      _InvestigationsWidgetConfig.defaultFields,
      Immutable.OrderedSet(),
      _InvestigationsWidgetConfig.defaultSort,
      _InvestigationsWidgetConfig.defaultMode
    );
  }
};
_InvestigationsWidgetConfig.defaultFields = Immutable.OrderedSet(["name", "status", "assigned_to", "created_at"]);
_InvestigationsWidgetConfig.defaultSort = new InvestigationsWidgetSortConfig("created_at", Direction.Descending);
_InvestigationsWidgetConfig.defaultMode = LIST_MODE;
let InvestigationsWidgetConfig = _InvestigationsWidgetConfig;
export {
  InvestigationsWidgetConfig as default
};
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  fields(value) {
    return new Builder(this.value.set("fields", value));
  }
  filters(value) {
    return new Builder(this.value.set("filters", value));
  }
  sort(value) {
    return new Builder(this.value.set("sort", value));
  }
  mode(value) {
    return new Builder(this.value.set("mode", value));
  }
  build() {
    const { fields, filters, sort, mode } = this.value.toObject();
    return new InvestigationsWidgetConfig(fields, filters, sort, mode);
  }
}
